import Phaser from 'phaser';

export default class BootScene extends Phaser.Scene
{
    constructor ()
    {
        super({ key: 'boot' });
    }

    preload ()
    {
        // load all files necessary for the loading screen
        this.load.json('assets', 'assets/json/assets.json');
        // this.load.json('game', 'assets/json/game.json');
        this.load.image('logo', 'assets/image/logo.png');
        this.load.image('loading_empty', 'assets/image/loading_empty.png');
        this.load.image('load_fill', 'assets/image/load_fill.png');
        this.load.image('desert_background', 'assets/image/desert_background.png');
        this.load.image('darker', 'assets/image/darker.png');
        
    }

    create ()
    {        
        this.scene.start('preload');
    }

}


//////////////////
// WEBPACK FOOTER
// ./src/scenes/boot.js
// module id = 1071
// module chunks = 0